import { useEffect, useState } from "react";
import { Button } from "V2.0/common/button";
import { PencilIcon } from "@heroicons/react/24/outline";
import ConversationTagsEdit from "./ConversationTagsEdit";
import { Badge } from "V2.0/common/badge";

function ConversationTags(props) {
  const { conversation, syncConversation, settings, fetchSettings, isViewOnly} = props;

  const [conversationTags, setConversationTags] = useState(
    conversation?.assignedTags || []
  );
  const [openTagEdit, setOpenTagEdit] = useState(false);

  useEffect(() => {
    setConversationTags(conversation?.assignedTags || []);
  }, [conversation]);

  const handleUpdateConversationTags = (createdTag) => {
    fetchSettings();
  };

  return (
    <>
      <div className="flex flex-col gap-y-2 border rounded-lg p-4 mt-6">
        <div className="flex justify-between">
          <p className="text-sm text-gray-400">Tags</p>
          {!isViewOnly && <Button outline onClick={() => setOpenTagEdit(true)}>
            <PencilIcon />
          </Button>}
        </div>
        <div>
          {Boolean(conversationTags.length) ? (
            <div className="flex flex-row flex-wrap gap-x-2 gap-y-4">
              {conversationTags.map((tag, idx) => {
                return <Badge color="blue" key={idx}>{tag}</Badge>;
              })}
            </div>
          ) : (
            <p className="text-sm text-gray-400">No tags assigned</p>
          )}
        </div>
      </div>
      {openTagEdit && (
        <ConversationTagsEdit
          open={openTagEdit}
          onClose={() => setOpenTagEdit(false)}
          workspaceId={conversation.workspace}
          workspaceTags={settings?.workspaceTags}
          conversationId={conversation._id}
          syncConversation={syncConversation}
          conversationTags={conversationTags}
          onCreateNewTags={handleUpdateConversationTags}
        />
      )}
    </>
  );
}

export default ConversationTags;
